import React, { useRef, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import SelectUnform, { OptionProps } from '../../../../components/SelectUnform';
import { CardSelectorProps } from '../../types';
import { Container, SelectorLabel, FormWrapper } from './styles';

const CardSelector: React.FC<CardSelectorProps> = ({
  cards,
  selectedCard,
  onCardSelect,
  disabled = false,
}) => {
  const formRef = useRef<FormHandles | null>(null);

  const cardOptions: OptionProps[] = cards.map((card) => ({
    id: card.id,
    name: `${card.insuredName} - ${card.userPlanCode}`,
  }));

  const handleCardChange = (name: string, id: string) => {
    const selectedCardData = cards.find((card) => card.id === id);
    if (selectedCardData) {
      onCardSelect(selectedCardData);
    }
  };

  useEffect(() => {
    formRef.current?.setFieldValue('selectedCard', selectedCard?.id || '');
  }, [selectedCard]);

  return (
    <Container>
      <Form
        ref={formRef}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit={() => {}}
        initialData={{
          selectedCard: selectedCard?.id || '',
        }}
      >
        <SelectorLabel htmlFor="selectedCard">
          Selecione a carteirinha que deseja visualizar
        </SelectorLabel>
        <SelectUnform
          name="selectedCard"
          disabled={disabled}
          className="notiflix-parents text-bold"
          widthContainerDesktop="100%"
          formLook
          options={cardOptions}
          callbackOnChange={handleCardChange}
        />
      </Form>
    </Container>
  );
};

export default CardSelector;
